if (!customElements.get('mp-points-badge')) {
  customElements.define(
    'mp-points-badge',
    class MPPointsBadge extends HTMLElement {
      connectedCallback() {
        this.rate = parseFloat(this.dataset.mpPointsRate || '0.05');
        this.perDollar = parseFloat(this.dataset.mpPointsPerDollar || '100');
        this.template = this.dataset.mpPointsTemplate || '';
        this.textEl = this.querySelector('[data-mp-points-text]');

        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => this.onVariantChange(event));
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      onVariantChange(event) {
        if (event.data.sectionId !== this.dataset.section) return;

        const variant = event.data.variant;
        if (!variant) {
          this.hidden = true;
          return;
        }

        const points = Math.round((variant.price / 100) * this.rate * this.perDollar);
        if (points <= 0) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
        if (this.textEl && this.template) {
          this.textEl.textContent = this.template.replace('__POINTS__', points);
        }
      }
    }
  );
}
